"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SSO_MERCER_LOGIN = exports.SSO_AGENT_IMPERSONATION = exports.OIDC_SSO_CALLBACK = exports.HOME = void 0;
var OIDC_SSO_CALLBACK = exports.OIDC_SSO_CALLBACK = "/sso/callback";
var HOME = exports.HOME = "/";
var SSO_AGENT_IMPERSONATION = exports.SSO_AGENT_IMPERSONATION = "Login/Impersonate";
var SSO_MERCER_LOGIN = exports.SSO_MERCER_LOGIN = "Login?ApplicationID=3e9ace1ec6994fca91fb28cfeda041e3&ReturnUrl=%2fAgentsOnly%2fAgentProfile%2fSingleSignOnReturnHandler.aspx&RedirectUrl=%2fAgentsOnly%2fAgentProfile%2fverifyLogon.aspx";